import ApiService from "services/ApiService";

const microService = "Asset";
const assetTypesController = "AssetTypes";
const badRequestCode = 400;

export const AssetTypesService = {
    getAssetTypesAndSubTypesForAccount() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/${microService}/${assetTypesController}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                });
        });
    },
    updateAssetTypeSubTypes(assetTypeId, subtypes) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/${microService}/${assetTypesController}/${assetTypeId}/Subtypes`, { subtypes }).then( 
                (response) => {
			        resolve(response);
				},
                (error) => {
                    if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to update asset type subtypes, please try again.");
					}
                }
            );
		});
	},
    excludeAssetTypes(excludedAssetTypeIds) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/${microService}/${assetTypesController}/Exclude`, { excludedAssetTypeIds }).then( 
                (response) => {
			        resolve(response);
				},
                (error) => {
                    if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to exclude asset type, please try again.");
					}
                }
            );
		});
	},
};